
export function replaceSubstrings(sentence, replaceKeys, toHtml) {
    const updatedString = sentence.replace(new RegExp(Object.keys(replaceKeys).join("|"), "g"), match => {
        return `<strong>${replaceKeys[match] || ''}</strong>`;
      });
    return !!toHtml ? <span dangerouslySetInnerHTML={{ __html: updatedString }} /> : updatedString;
}

export function fixTrims(propertyDataList){
  return propertyDataList.map(({ value, ...rest }) => ({ ...rest, value: value?.trim() }))
 }
